export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_702873c0-fdeb-40e2-951c-52ad4e4fd7f3/artifacts/ga0u4l8a_Swingle%20Venues%20Logo%20.png";

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/pricing", label: "Pricing" },
  { to: "/about", label: "About" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];

export const SERVICES = [
  {
    id: "websites",
    title: "Websites",
    kicker: "01",
    short:
      "Enterprise-grade websites built for late-night venues. Fast, beautiful, and built to convert.",
    long:
      "A bespoke website for your venue with a powerful dashboard at the heart of it. Add events, monitor ticket sales, track memberships and update content — all from one place. Designed to look incredible on every screen and engineered to load in milliseconds.",
    bullets: [
      "Custom design that matches your brand",
      "Self-serve dashboard for your team",
      "SEO-optimised and lightning fast",
      "Built-in events, tickets & memberships",
    ],
    image:
      "https://images.unsplash.com/photo-1500217052183-bc01eee1a74e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    id: "events",
    title: "Event Creation & Management",
    kicker: "02",
    short:
      "Plan, publish and promote events in minutes. Manage everything from a single dashboard.",
    long:
      "From a Friday club night to a one-off live show — create events, set ticket tiers, schedule on-sales and watch sales roll in. Real-time analytics show you what's working and what's not, so you can react fast.",
    bullets: [
      "Unlimited events, unlimited tiers",
      "Scheduled on-sales & early access",
      "Real-time sales analytics",
      "Promoter and guest list tools",
    ],
    image:
      "https://images.unsplash.com/photo-1778318730348-e37057121b12?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    id: "tickets",
    title: "Digital Ticket Sales",
    kicker: "03",
    short:
      "Keep 100% of the booking fees. No middlemen. The single biggest revenue lever for your venue.",
    long:
      "Traditional ticketing platforms keep the booking fee. We don't. Every penny of the booking fee goes straight to your bottom line. Customers get a beautiful digital ticket with QR scan-in. You get the cash.",
    bullets: [
      "You keep 100% of booking fees",
      "QR-coded digital tickets",
      "Door scan-in via any phone",
      "Refunds, transfers & resends in one tap",
    ],
    image:
      "https://images.unsplash.com/photo-1501281668745-f7f57925c3b4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    id: "memberships",
    title: "Digital Membership Cards",
    kicker: "04",
    short:
      "Apple & Google Wallet membership cards that drive repeat visits.",
    long:
      "Turn punters into regulars. Issue beautifully designed digital membership cards that live in your customers' phones. Tiered perks, automatic renewals, push updates — your loyalty programme, supercharged.",
    bullets: [
      "Apple Wallet & Google Wallet ready",
      "Tiered memberships with custom perks",
      "Push notifications for drops & events",
      "Automatic renewals & expiry handling",
    ],
    image:
      "https://images.unsplash.com/photo-1545128485-c400e7702796?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    id: "epos",
    title: "ePoS Systems",
    kicker: "05",
    short:
      "Tills, card machines and inventory — with next-day payouts, no contracts and low fees.",
    long:
      "A modern point-of-sale built for the pace of a busy bar. Crisp hardware, fast card machines, and rates that don't bleed your margins. No long-term contracts. Easy in, easy out. Sleep knowing your cash hits your account the next morning.",
    bullets: [
      "Next-day payouts, every day",
      "No long contracts, no exit fees",
      "Industry-leading transaction rates",
      "Stock, staff and reporting built in",
    ],
    image:
      "https://images.unsplash.com/photo-1777678930403-3d87fad8fd60?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
];

export const FAQS = [
  {
    q: "I'm happy with some aspects of my business — is that an issue?",
    a: "Not at all. If you just want to use our ticketing platform, you don't need a website, or you don't need card machines and tills — that's absolutely fine. You can pick and choose which services you use from us.",
  },
  {
    q: "What does it cost?",
    a: "Every venue is different — a venue selling 4,000 tickets per month will be very different to a venue selling 300 tickets a month. We have nothing to hide on our pricing. Schedule a call with us to talk through what you need and we'll have a quote with you within 12 hours.",
  },
  {
    q: "How does Swingle actually make me money?",
    a: "Two ways. First, we let you keep 100% of the booking fees on every ticket sold — money that normally goes to third-party ticketing platforms. Second, we replace your existing card machine setup with lower transaction rates, reducing what you currently pay to acquirers. Together, these typically add thousands to your monthly bottom line.",
  },
  {
    q: "Is there a long contract?",
    a: "No. We don't believe in long contracts. Easy in, easy out — we earn our place by performing every month. If we're not adding value, you're free to leave.",
  },
  {
    q: "How long does it take to get live?",
    a: "Weeks, not months. Most venues are fully live within 2–4 weeks of signing — website, ticketing, memberships and ePoS all switched on and ready for your next big weekend.",
  },
  {
    q: "Do I need to be technical to use the dashboard?",
    a: "Not at all. The dashboard is designed for venue managers, not engineers. If you can use Instagram, you can use Swingle. We also train your team on day one.",
  },
  {
    q: "Will my staff need new hardware?",
    a: "We provide everything required. Card machines, tills and any peripherals — all included as part of the rollout. No surprise hardware bills.",
  },
  {
    q: "When do payouts hit my bank?",
    a: "Next day. Every day. No 7-day holds, no weekend delays. Cash in, cash out — fast.",
  },
  {
    q: "Can I migrate from my current ticketing or website provider?",
    a: "Yes. We handle the migration — events, attendees, member lists, the lot. Your customers won't even notice the switch, except for a slicker checkout.",
  },
  {
    q: "Which UK regions do you cover?",
    a: "All of them. We're a UK-based team working with venues from the south coast to the highlands.",
  },
];

export const PROCESS_STEPS = [
  {
    step: "01",
    title: "Get In Touch & Schedule A Call",
    body:
      "20–30 minutes of your time. Run us through what you're currently using, what's working and what isn't. We'll show you exactly where the money is being left on the table.",
  },
  {
    step: "02",
    title: "Get A Confirmed, No-BS Price",
    body:
      "No long contracts. No hidden line items. A clear, transparent quote so you know exactly what you're getting and what it costs. Easy in, easy out.",
  },
  {
    step: "03",
    title: "Live In Weeks. Not Months.",
    body:
      "Your venue supercharged in weeks. We handle the migration, hardware, training and launch. By your next big weekend, you're already making more money.",
  },
];
